import React from 'react';

export default function UnAuthorized(props) {
  return (
    <>
    <h1>Access Denied</h1>
    <div>Sorry about that, but you do not have the permission to access the requested page</div>
    </>
  )
}